(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artwork-enhancements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('artwork-product-enhancements')) {
  customElements.define('artwork-product-enhancements', class extends HTMLElement {
    connectedCallback() {
      this.product = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.product || this.started) return;
      this.started = true;
      this.bar = this.querySelector('.artwork-preview__sticky');
      this.button = this.querySelector('[data-artwork-add]');
      this.price = this.querySelector('[data-artwork-price]');
      this.selection = this.querySelector('[data-artwork-selection]');
      this.nativeButton = this.product.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
      if (!this.nativeButton) return;
      this.optionsReached = false;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.onMedia = () => this.updateVisibility();
      this.mobile.addEventListener('change', this.onMedia);
      this.button.addEventListener('click', () => {
        if (this.button.disabled || this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') return;
        this.nativeButton.click();
      });
      this.offerButton = this.product.querySelector('[data-artwork-offer]');
      this.offerButton?.addEventListener('click', () => this.nativeOffer?.click());
      this.onChange = (event) => {
        if (event.target.closest('variant-selects')) {
          this.openGuides = Array.from(this.product.querySelectorAll('[data-artwork-guide][open]')).map(node => node.dataset.artworkGuide);
          this.optionsReached = true;
          this.button.disabled = true;
          this.selection.textContent = this.dataset.pending;
          this.price.textContent = '';
          this.pending = true;
        }
      };
      this.product.addEventListener('change', this.onChange);
      this.formObserver = new MutationObserver(() => this.scheduleSync());
      this.formObserver.observe(this.nativeButton, { attributes: true, childList: true, subtree: true });
      const nativePrice = this.product.querySelector(`#price-${this.dataset.section}`);
      if (nativePrice) this.formObserver.observe(nativePrice, { attributes: true, childList: true, subtree: true });
      this.offVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        this.pending = false;
        this.sync();
      });
      this.offError = subscribe(PUB_SUB_EVENTS.cartError, () => {
        this.nativeButton.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
      this.intersection = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === this.nativeButton) this.nativeVisible = entry.isIntersecting;
          if (entry.target === this.product.querySelector('.product__title') && entry.boundingClientRect.bottom < 0) this.optionsReached = true;
        }
        this.updateVisibility();
      });
      this.intersection.observe(this.nativeButton);
      this.intersection.observe(this.product.querySelector('.product__title'));
      this.offerObserver = new MutationObserver((entries) => {
        if (!entries.some(entry => entry.addedNodes.length || entry.removedNodes.length)) return;
        if (this.offerFrame) return;
        this.offerFrame = requestAnimationFrame(() => { this.offerFrame = null; this.findOffer(); this.updateVisibility(); });
      });
      this.offerObserver.observe(document.body, { childList: true, subtree: true });
      this.findOffer();
      this.sync();
    }
    scheduleSync() {
      if (this.syncFrame) return;
      this.syncFrame = requestAnimationFrame(() => { this.syncFrame = null; this.sync(); });
    }
    sync() {
      const selected = this.product.querySelector('variant-selects [data-selected-variant]');
      let variant;
      try { variant = JSON.parse(selected?.textContent || 'null'); } catch { variant = null; }
      const unavailable = this.nativeButton.disabled && this.nativeButton.textContent.trim() === window.variantStrings.unavailable;
      if (unavailable) this.pending = false;
      const busy = this.nativeButton.getAttribute('aria-disabled') === 'true' || this.nativeButton.classList.contains('loading');
      this.button.disabled = this.pending || this.nativeButton.disabled || busy || !variant?.available;
      this.button.textContent = this.nativeButton.querySelector('span')?.textContent.trim() || window.variantStrings.addToCart;
      if (this.pending) return;
      const deliverySource = this.product.querySelector('[data-artwork-delivery-source]');
      const deliveryDestination = this.product.querySelector('[data-artwork-delivery-destination]');
      if (deliverySource && deliveryDestination && this.deliverySource !== deliverySource) {
        deliveryDestination.replaceChildren(deliverySource.content.cloneNode(true));
        this.deliverySource = deliverySource;
        for (const guide of this.openGuides || []) {
          this.product.querySelector(`[data-artwork-guide="${guide}"]`)?.setAttribute('open', '');
        }
      }
      const price = this.product.querySelector('.artwork-preview__selection-total strong');
      this.price.textContent = unavailable ? '' : price?.textContent.trim() || '';
      this.selection.textContent = variant && !unavailable ? variant.title.replaceAll(' / ', ' · ') : this.dataset.unavailable;
      this.updateVisibility();
    }
    findOffer() {
      const button = Array.from(document.querySelectorAll('button')).find(node => node !== this.offerButton && /^get\s*10%\s*off$/i.test((node.textContent || node.getAttribute('aria-label') || '').trim()));
      if (!button) {
        this.offerRoot?.classList.remove('artwork-preview__native-offer');
        if (this.offerButton) this.offerButton.hidden = true;
        this.nativeOffer = null;
        return;
      }
      let root = button;
      let floating = null;
      for (let depth = 0; root && root !== document.body && depth < 8; depth++, root = root.parentElement) {
        if (getComputedStyle(root).position === 'fixed' && root.querySelectorAll('button').length <= 3) floating = root;
      }
      if (!floating || !this.offerButton) return;
      this.nativeOffer = button;
      this.offerRoot = floating;
      floating.classList.add('artwork-preview__native-offer');
      this.offerButton.hidden = false;
    }
    updateVisibility() {
      const overlay = document.body.classList.contains('overflow-hidden') || document.querySelector('cart-drawer.active, cart-notification.active, pickup-availability-drawer[open]');
      this.bar.hidden = !this.mobile.matches || !this.optionsReached || this.nativeVisible || !!overlay;
    }
    disconnectedCallback() {
      this.formObserver?.disconnect();
      this.offerObserver?.disconnect();
      this.intersection?.disconnect();
      this.offVariant?.();
      this.offError?.();
      this.mobile?.removeEventListener('change', this.onMedia);
      this.product?.removeEventListener('change', this.onChange);
      this.offerRoot?.classList.remove('artwork-preview__native-offer');
      cancelAnimationFrame(this.syncFrame);
      cancelAnimationFrame(this.offerFrame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
